module.exports = __webpack_public_path__ + "static/media/text_understand_video.2e40bcfa.mp4";